/**
 * Finds if object empty
 * @param {Record<string, any>}: input object
 * @returns {boolean}
 */
export const isNotEmptyObject = (object: Record<string, any>): boolean => object && !!Object.keys(object).length;

/**

 * @param {Record<string, any>}: input object
 * @param {number} index: index number of element to get key
 * @returns {string}: key value or empty string
 */
export const getNthObjectKey = (object: Record<string, any>, index: number): unknown =>
    (object && Object.keys(object)[index]) || "";
